import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table, TableBody, TableCell, TableHead,
  TableRow, Box, FormControlLabel, RadioGroup,
  Typography, FormControl, Button,
} from '@material-ui/core';
import {
  FILE_ID,
  CHAR_CODE,
} from '../../../common/const';
import config from '../../../common/config';
import {
  setSystemLodingFLg,
  setInitMessage,
  setErrorMessage,
} from '../../actions/CommonAction';
import {
  setDispTab,
  fileUploadExecute,
  checkUploadFileStatus,
  searchUploadJobList,
  filterJobList,
  setCharCode,
  setAdditionalItemsId,
} from '../../actions/UploadAction';
import styles from './UploadSettingComponent.module.css';
import CustomRadio from '../common/CustomRadio';

class UploadSettingComponent extends Component {
  constructor() {
    super();
    const additionalItemsIndex = 1;
    this.state = {
      // 取引情報ファイルインデックス
      additionalItemsIndex,
    };
  }

  componentDidMount = async () => {
    const {
      setSystemLodingFLgAct,
      checkUploadFileStatusAct,
      setAdditionalItemsIdAct,
    } = this.props;
    const {
      additionalItemsIndex,
    } = this.state;

    setSystemLodingFLgAct(true);
    // アップロードファイルステータスチェック
    await checkUploadFileStatusAct();
    setSystemLodingFLgAct(false);
    // アップロードファイルIDを初期化
    const initAdditionalItemsIdList = [];
    initAdditionalItemsIdList.push(FILE_ID.ADDITIONAL_ITEMS_FILE.concat('-', additionalItemsIndex));
    setAdditionalItemsIdAct(initAdditionalItemsIdList);
  }

  // ファイルクリック
  onClickFile = (id) => {
    const file = document.getElementById(id);
    file.click();
  }

  // ファイル選択
  onChangeFile = (id, messageId) => {
    const file = document.getElementById(id).files[0];
    if (file !== undefined) {
      document.getElementById(messageId).innerText = file.name;
    } else {
      document.getElementById(messageId).innerText = '選択されていません';
    }
  }

  // 追加ボタン押下(取引情報)
  onClickAdditionalItemsAddButton = () => {
    const {
      additionalItemsIndex,
    } = this.state;
    const {
      additionalItemsIdList,
      setAdditionalItemsIdAct,
    } = this.props;
    const index = additionalItemsIndex + 1;
    additionalItemsIdList.push(FILE_ID.ADDITIONAL_ITEMS_FILE.concat('-', index));
    setAdditionalItemsIdAct(additionalItemsIdList);
    this.setState({
      additionalItemsIndex: index,
    });
  }

  // 削除ボタン押下(取引情報)
  onClickAdditionalItemsDeleteButton = (targetId) => {
    const {
      additionalItemsIdList,
      setAdditionalItemsIdAct,
    } = this.props;
    setAdditionalItemsIdAct(additionalItemsIdList.filter((id) => id !== targetId));
  }

  render() {
    const {
      charCode,
      setCharCodeAct,
      additionalItemsIdList,
    } = this.props;

    // 取引情報リスト作成
    const additionalItemsAccordionList = [];
    additionalItemsIdList.forEach((id) => {
      const messageId = 'message'.concat(id);
      additionalItemsAccordionList.push(
        <TableRow className={`${styles.row}`} key={id}>
          <TableCell className={`${styles.uploadFileRow}`}>
            <Box>
              <Box className={`${styles.condition}`}>
                <div className={`${styles.title}`}>
                  <Button
                    variant="contained"
                    className={[
                      additionalItemsIdList.length === 1 ? `${styles.tooltip} ${styles.disabledBtn} addDelete` : `${styles.tooltip} addDelete`,
                    ].join(' ')}
                    onClick={() => this.onClickAdditionalItemsDeleteButton(id)}
                    disabled={additionalItemsIdList.length === 1}
                  >
                    <span>－</span>
                    <Box className={`${styles.description}`}>削除</Box>
                  </Button>
                </div>
                <Box className={`${styles.fileSelectBtn}`}>
                  <button
                    type="button"
                    className={`${styles.fileButton}`}
                    onClick={() => this.onClickFile(id)}
                  >
                    ファイルを選択
                  </button>
                  <input type="file" accept=".csv" id={id} onChange={() => this.onChangeFile(id, messageId)} className={`${styles.uploadFile}`} />
                </Box>
                <Box className={`${styles.fileSelectStatus}`}>
                  <span id={messageId}>選択されていません</span>
                </Box>
              </Box>
            </Box>
          </TableCell>
        </TableRow>,
      );
    });

    return (
      <Box className={`${styles.uploadsetting}`}>
        <Box display="flex" alignItems="center" flexDirection="column" className={`${styles.uploadsettingframe}`}>
          <Table className={`${styles.uploadsettingfield}`}>
            <TableHead className={`${styles.header}`}>
              <TableRow>
                <TableCell className={`${styles.headerTitle} ${styles.topRadius}`}>アップロード設定</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={`${styles.row}`}>
                <TableCell className={`${styles.bottomRadius}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.rowTitle}`}>文字コード</Typography>
                    <Box>
                      <FormControl component="fieldset">
                        <RadioGroup row>
                          <FormControlLabel
                            value={CHAR_CODE.SJIS}
                            control={<CustomRadio />}
                            label="Shift-JIS"
                            checked={charCode === CHAR_CODE.SJIS}
                            onChange={() => setCharCodeAct(CHAR_CODE.SJIS)}
                          />
                          <FormControlLabel
                            value={CHAR_CODE.UTF8}
                            control={<CustomRadio />}
                            label="UTF-8"
                            checked={charCode === CHAR_CODE.UTF8}
                            onChange={() => setCharCodeAct(CHAR_CODE.UTF8)}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Box className={`${styles.searchResultarea}`}>
            <div className={`${styles.searchResultareaTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead className={`${styles.header}`}>
                  <TableRow>
                    <TableCell className={`${styles.headerTitle} ${styles.topRadius}`}>アップロードファイル</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div className={`${styles.searchResultareaTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {additionalItemsAccordionList}
                </TableBody>
              </Table>
            </div>
          </Box>
          <div className={`${styles.buttonCondition}`}>
            <div className={`${styles.addButton}`}>
              {additionalItemsIdList.length < config.MAX_ADD_COUNT.UPLOAD_COMPANY
                && (
                  <Button
                    variant="contained"
                    className={`${styles.btnSize} addAll`}
                    onClick={() => this.onClickAdditionalItemsAddButton()}
                  >
                    <span className="button-symbol">＋</span>
                    追加
                  </Button>
                )}
              {!(additionalItemsIdList.length < config.MAX_ADD_COUNT.UPLOAD_COMPANY)
                && (
                  <Button
                    variant="contained"
                    className={`${styles.btnSize} ${styles.disabledBtn} addAll`}
                    onClick={() => this.onClickAdditionalItemsAddButton()}
                    disabled
                  >
                    <span className="button-symbol">＋</span>
                    追加
                  </Button>
                )}
            </div>
          </div>
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    selectSequenceId: state.upload.selectSequenceId,
    charCode: state.upload.charCode,
    additionalItemsIdList: state.upload.additionalItemsIdList,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrorMessageAct: (errorMessage) => dispatch(setErrorMessage(errorMessage)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    checkUploadFileStatusAct: () => dispatch(checkUploadFileStatus()),
    searchUploadJobListAct: (excutionDate) => dispatch(searchUploadJobList(excutionDate)),
    filterJobListAct: () => dispatch(filterJobList()),
    setAdditionalItemsIdAct: (obj) => dispatch(setAdditionalItemsId(obj)),
    fileUploadExecuteAct: (
      additionalItemsFile,
    ) => dispatch(fileUploadExecute(
      additionalItemsFile,
    )),
    setCharCodeAct: (str) => dispatch(setCharCode(str)),
  }),
)(UploadSettingComponent);
